import { NEW_ORDER_SET_PRODUCTS, NEW_ORDER_RESET_PRODUCTS } from "../actions/new_order_actions";

const initialState = {
  newOrderProducts: []
};

export const newOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case NEW_ORDER_SET_PRODUCTS: {
      return {
        ...state,
        newOrderProducts: [...action.payload]
      }
    }
    case NEW_ORDER_RESET_PRODUCTS: {
      return {
        ...state,
        newOrderProducts: []
      }
    }
    default: return state
  }
}
